<script setup lang="ts">
import { GpModal, GpTextInput } from '@gportal/uikit';
import { faArrowRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { computed, ref } from 'vue';
import ModalFooterBtn from 'gpcore-uikit/components/new/ModalFooterBtn.vue';

const props = defineProps<{
  show: boolean;
  isLoading: boolean;
  fqdnToConfirm: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'confirm'): void;
}>();

const fqdn = ref('');

const isConfirmDisabled = computed(() => {
  if (props.fqdnToConfirm == null) return true;

  return props.fqdnToConfirm.toLocaleLowerCase() !== fqdn.value.toLocaleLowerCase();
});
</script>

<template>
  <GpModal
    :is-opened="show"
    :header-icon="faArrowRotateLeft"
    :close-on-backdrop="false"
    header-text="Confirm reinstall"
    @close="emit('close')"
  >
    <template #content>
      <div class="tw-mb-8 tw-px-4">
        <GpTextInput
          label="Confirm node hostname"
          input-id="node-reinstall__confirm-fqdn"
          v-model="fqdn"
          :placeholder="fqdnToConfirm"
        />
      </div>
    </template>
    <template #footer>
      <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-4">
        <ModalFooterBtn btn-type="cancel" size="sm" label="Cancel" @click="emit('close')" />
        <ModalFooterBtn
          size="sm"
          label="Confirm"
          :disabled="isConfirmDisabled || isLoading"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </GpModal>
</template>

<style scoped></style>
